"use client";

import type { FC } from "react";

import { useInView } from "@ui/lib/useInView";
import { useRef, useState } from "react";

import { AccordionSlidesAsset } from "./AccordionSlidesAsset";
import type { AccordionSlidesItem, NormalizedAsset } from "./AccordionSlidesShared";

export interface AccordionSlidesAssetContentProps {
  item?: AccordionSlidesItem;
  nextAsset?: NormalizedAsset;
  nextIdx: number;
  selectedAsset?: NormalizedAsset;
  selectedIdx: number;
}

export const AccordionSlidesAssetContent: FC<AccordionSlidesAssetContentProps> = ({
  item,
  nextAsset,
  nextIdx,
  selectedAsset,
  selectedIdx,
}) => {
  const inViewRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(true);
  const [showControls, setShowControls] = useState(true);

  const isInView = useInView(inViewRef, { once: false, threshold: 0.1 }) ?? false;

  const toggleMute = () => setIsMuted(prev => !prev);
  const handleInteraction = () => setShowControls(true);

  return (
    <div className='tw-w-full' ref={inViewRef}>
      {selectedAsset && (
        <AccordionSlidesAsset
          key={`${selectedAsset.type}-${selectedIdx}`}
          animationKey={selectedIdx}
          asset={selectedAsset}
          inView={isInView}
          isMuted={isMuted}
          item={item}
          name={selectedAsset.type}
          onInteraction={handleInteraction}
          showControls={showControls}
          toggleMute={toggleMute}
          videoRef={videoRef}
        />
      )}

      {isInView && nextAsset?.type === "backgroundForegroundImage" && nextAsset.foreground && (
        <div className='tw-pointer-events-none tw-absolute tw-inset-0 tw-opacity-0'>
          <AccordionSlidesAsset
            key={`${nextAsset.type}-preload-${nextIdx}`}
            animationKey={`preload-${nextIdx}`}
            asset={nextAsset}
            inView={isInView}
            isMuted={isMuted}
            isPreload
            name={nextAsset.type}
            onInteraction={handleInteraction}
            showControls={showControls}
            toggleMute={toggleMute}
            videoRef={videoRef}
          />
        </div>
      )}
    </div>
  );
};
